import { useState } from "react";
import { Film, Check, Loader2 } from "lucide-react";
import { Panel } from "./Panel";

const STEPS = [
  ["rendering_video", "Rendering spinning video"],
  ["removing_background", "Removing background"],
  ["encoding", "Encoding WebM, MOV & MP4"],
];

const Progress = ({ status }) => {
  const idx = STEPS.findIndex(([k]) => k === status);
  const pct = Math.round(((idx + 0.5) / STEPS.length) * 100);
  return (
    <div className="space-y-4 mb-5">
      <div data-testid="render-progress-bar" className="h-1.5 rounded-full bg-[#1e2638] overflow-hidden">
        <div className="h-full bg-[#00ff87] transition-[width] duration-700" style={{ width: `${pct}%` }} />
      </div>
      <ul className="space-y-2.5">
        {STEPS.map(([k, label], i) => (
          <li key={k} data-testid={`render-step-${k}`}
            className={`flex items-center gap-3 text-sm ${i < idx ? "text-gray-400" : i === idx ? "text-white" : "text-gray-600"}`}>
            {i < idx ? <Check className="w-4 h-4 text-[#00ff87]" /> : i === idx ? <Loader2 className="w-4 h-4 animate-spin text-[#00ff87]" /> : <span className="w-4 h-4 rounded-full border border-gray-700" />}
            {label}
          </li>
        ))}
      </ul>
      <p data-testid="render-status-text" className="font-mono-ui text-[11px] uppercase tracking-widest text-gray-500">
        Usually 3–8 minutes. You can leave this page open.
      </p>
    </div>
  );
};

export const VideoPanel = ({ approvedId, rendering, onMake }) => {
  const [duration, setDuration] = useState("6");
  return (
    <Panel step="03 / Revolve" title="Spinning video" testid="video-panel">
      <p className="text-sm text-gray-400 mb-5 leading-relaxed">
        {approvedId ? "Your approved still becomes the first and last frame, so it loops." : "Approve a chrome still first."}
      </p>
      {rendering && <Progress status={rendering.status} />}
      <div className="font-mono-ui text-[11px] uppercase tracking-widest text-gray-500 mb-2">Length</div>
      <div className="grid grid-cols-4 gap-2 mb-5" data-testid="duration-picker">
        {["5", "6", "7", "8"].map((d) => (
          <button key={d} data-testid={`duration-${d}`} onClick={() => setDuration(d)}
            className={`rounded-lg py-2 text-sm font-mono-ui btn-ghost ${duration === d ? "!border-[#00ff87] text-[#00ff87]" : "text-gray-400"}`}>
            {d}s
          </button>
        ))}
      </div>
      <button data-testid="make-video-button" disabled={!approvedId || !!rendering} onClick={() => onMake(duration)}
        className="btn-chrome w-full rounded-full py-3.5 font-semibold flex items-center justify-center gap-2">
        {rendering ? <Loader2 className="w-4 h-4 animate-spin" /> : <Film className="w-4 h-4" />}
        {rendering ? "Rendering…" : "Make spinning video"}
      </button>
    </Panel>
  );
};
